module.exports = __webpack_public_path__ + "static/media/music.d4db2820.svg";